import { combineReducers } from 'redux'
import { history } from 'js/redux/middleware/history'
import { connectRouter } from 'connected-react-router'
import auth from './auth'
import user from './user'
import loader from './loader'
import organisation from './organisation'
import article from './article'
import category from './category'
import dataset from './dataset'
import discovery from './discovery'
import insight from './insight'
import table from './table'
import help from './help'
import search from './search'
import site from './site'
import menu from './menu'
import webpage from './webpage'
import tag from './tag'
import carousel from './carousel'

export default combineReducers({
  article,
  auth,
  carousel,
  category,
  dataset,
  discovery,
  help,
  insight,
  loader,
  menu,
  organisation,
  router: connectRouter(history),
  search,
  site,
  table,
  tag,
  user,
  webpage
})
